import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { TextWrapper, Wrapper, TextWrapperSpan } from "../../../constants/common/StyledGlobalConstants";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";

const { TABLET } = DEVICE_BREAKPOINTS;

export const CountryMapping = {
  USA: "United States",
};

const AppointmentDetails = ({ appointmentDateAndTime, appoinmentLocationAndDuration }) => {
  const { slotDate, startTime } = appointmentDateAndTime;
  const { address1, address2, city, stateCode, zipCode, country, appointmentLength } = appoinmentLocationAndDuration;

  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const isMobile = windowSize.width < TABLET;

  const renderDetail = (label, value, margin = isMobile ? "1rem" : "4px") => (
    <TextWrapper marginTop={`${margin} !important`} lineHeight="1.25rem">
      <TextWrapperSpan fontWeight="700">{label}:</TextWrapperSpan>
      {isMobile ? <TextWrapper marginTop="0.5rem !important">{value}</TextWrapper> : <TextWrapperSpan marginLeft="0.5rem">{value}</TextWrapperSpan>}
    </TextWrapper>
  );

  function getAppointmentDurationText(appointmentLength) {
    const formattedLength = parseFloat(appointmentLength.toFixed(1));
    let unit = "hour";
    if (formattedLength > 1) {
      unit = "hours";
    }
    return `Approximately ${formattedLength} ${unit}`;
  };

  const address2Value = address2 ? `, ${address2}` : "";

  return (
    <Wrapper marginTop="2rem">
      <TextWrapper fontSize={isMobile ? "1.25rem" : "1.5rem"} fontWeight="700" lineHeight={isMobile ? "1.5rem" : "2rem"}>
        Appointment details
      </TextWrapper>
      <Wrapper marginTop="1rem" fontSize="0.875rem" fontWeight="400" border="1px solid #D8DADA" borderRadius="8px" lineHeight="1.5rem">
        <Wrapper padding="1.5rem">
          {renderDetail("Date and time", `${slotDate} at ${startTime}`, 0)}
          {renderDetail(
            "Location",
            `${address1}${address2Value}, ${city}, ${stateCode} ${zipCode}, ${CountryMapping[country] || country}`
          )}
          {renderDetail("Duration", getAppointmentDurationText(appointmentLength))}
        </Wrapper>
      </Wrapper>
    </Wrapper>
  );
};
AppointmentDetails.propTypes = {
  appointmentDateAndTime: PropTypes.shape({
    slotDate: PropTypes.string.isRequired,
    startTime: PropTypes.string.isRequired,
  }).isRequired,
  appoinmentLocationAndDuration: PropTypes.shape({
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string,
    city: PropTypes.string.isRequired,
    stateCode: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    appointmentLength: PropTypes.number.isRequired,
  }).isRequired,
};

export default AppointmentDetails;